/* @flow */
import * as React from 'react';
import { translate, type TFunction } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter, type RouterHistory } from 'common/components/core/router';
import ChangePasswordBase from './ChangePasswordBase';
import { Text, Stack, Card } from '@locus-taxy/neo-ui';
import changePasswordIds from 'common/tests/changePassword/changePasswordIds.json';

type OwnProps = {
    username: string
};
type Props = {
    t: TFunction,
    history: RouterHistory,
    ...OwnProps
};

class ChangePassword extends React.PureComponent<Props> {
    redirectToHome = () => {
        const { history } = this.props;
        history.push({
            pathname: '/'
        });
    };

    onPasswordUpdate = () => {
        this.redirectToHome();
    };

    renderHeader = () => {
        const { t } = this.props;
        return (
            <Stack space="tiny">
                <Text fontSize={4} data-test-id={changePasswordIds.title}>
                    {t('changePasswordPageCardTitle')}
                </Text>
            </Stack>
        );
    };

    render() {
        const { username } = this.props;
        return (
            <Card size="large">
                <Stack space="small">
                    <ChangePasswordBase
                        username={username}
                        onUpdatePasswordSuccess={this.redirectToHome}
                        onCancel={this.redirectToHome}
                        renderHeader={this.renderHeader}
                        allowNavigation
                        forceShow
                    />
                </Stack>
            </Card>
        );
    }
}

export default (compose(
    withRouter,
    translate('settings')
)(ChangePassword): React.AbstractComponent<OwnProps>);
